// BeachSportss Theme JS

// ── SEARCH ──
function openSearch(){
  document.getElementById('sOverlay').classList.add('open');
  setTimeout(()=>document.getElementById('sInput').focus(),50);
}
function closeSearch(){
  document.getElementById('sOverlay').classList.remove('open');
}
document.addEventListener('keydown',e=>{
  if(e.key==='Escape') closeSearch();
});

// ── LEAGUE PILL ACTIVE STATE (visual only, does not block navigation) ──
document.querySelectorAll('.pill').forEach(p => {
  p.addEventListener('click', function() {
    document.querySelectorAll('.pill').forEach(x => x.classList.remove('on'));
    this.classList.add('on');
    // navigation proceeds naturally via the href
  });
});

// ── HERO SLIDESHOW ──
let currentSlide = 0;
const totalSlides = document.querySelectorAll('.slide').length;
let autoTimer = null;

function showSlide(n){
  if(n >= totalSlides) n = 0;
  if(n < 0) n = totalSlides - 1;
  currentSlide = n;
  document.querySelectorAll('.slide').forEach((s,i)=>{
    s.classList.toggle('active', i === currentSlide);
  });
  document.querySelectorAll('.sdot').forEach((d,i)=>{
    d.classList.toggle('active', i === currentSlide);
  });
}

function moveSlide(dir){
  clearInterval(autoTimer);
  showSlide(currentSlide + dir);
  startAuto();
}

function goSlide(n){
  clearInterval(autoTimer);
  showSlide(n);
  startAuto();
}

function startAuto(){
  autoTimer = setInterval(()=> showSlide(currentSlide + 1), 5500);
}

// Kick off on load
document.addEventListener('DOMContentLoaded', function(){
  if(document.querySelector('.slide')) startAuto();
});

// Keyboard nav
document.addEventListener('keydown', e => {
  if(e.key === 'ArrowLeft') moveSlide(-1);
  if(e.key === 'ArrowRight') moveSlide(1);
});

